import i18n from '@/i18n';
import { getInfoUserLocalStorage } from '@/utils/handlers';
import { options } from './components/setting-design/constants';
import { toCalendarEnd, createIdEventRangeDate } from '@/views/pages/phase2/manager-form/components/setting-calendar/constants';
import { initSerialCodeInputBlock } from '@/views/pages/phase2/manager-form/components/setting-page/constants';
import { isRolePartner } from '@/views/pages/require/handlers.js';
import { OPTION_DESIGN_PRIZE_FORM_B } from '@/views/pages/phase2/manager-form/components/setting-page/components/form-b/constants';

const HEADE_DEFAULT = `<meta name="viewport" content="width=device-width,initial-scale=1"/>
<meta name="format-detection" content="telephone=no">
<style>
  /* form */
  --form-font-family: inherit;
  --form-font-size: inherit;
  --form-color: inherit;
  --form-background-color: inherit;
  --form-background-image: inherit;
  --form-background-size: auto;
  --form-background-repeat: no-repeat;
  --form-background-position: left top;
  --form-background-attachment: scroll;
  /* // error */
  --form-error-font-family: inherit;
  --form-error-font-size: 80%;
  --form-error-color: #ff3d60;
  --form-error-list-style-type: inherit;
  /* // placeholder */
  --form-placerholder-color: inherit;
  /* // container__form */
  --container--form-width: 100%;
  --form-width-fm-question: auto;
  --form-width-fm-answer: auto;
  --form-padding-top: auto;
  --form-padding-bottom: auto;
  --form-padding-left: auto;
  --form-padding-right: auto;
  --form--border-type: none;
  --form--border-color: none;
  --form--border-width: inherit;
  --form-padding-inline: 30px;
  --form-padding-block: 30px;
  --form-background-color-fm-question: inherit;
  --form-background-color-fm-answer: inherit;
  --form-text-align-fm-question: inherit;
  --form-text-align-fm-answer: inherit;
  --form-vertical-align-fm-question: inherit;
  --form-vertical-align-fm-answer: inherit;
  /* // table__form */
  --table--form-border-collapse: collapse;
  --table--form-border-type: none;
  --table--form-border-color: none;
  --table--form-border-width: inherit;
  --table--margin-inset: 0;

.body__form * {
	 font-family: var(--form-font-family);
}
 .body__form * audio, .body__form * canvas, .body__form * embed, .body__form * iframe, .body__form * img, .body__form * object, .body__form * svg, .body__form * video {
	 display: inherit;
}
 .body__form {
	 font-size: var(--form-font-size);
	 color: var(--form-color);
	 background-color: var(--form-background-color);
	 background-image: var(--form-background-image);
	 background-size: var(--form-background-size);
	 background-repeat: var(--form-background-repeat);
	 background-position: var(--form-background-position);
	 background-attachment: var(--form-background-attachment);
	 padding-top: var(--form-padding-top);
	 padding-left: var(--form-padding-left);
	 padding-bottom: var(--form-padding-bottom);
	 padding-right: var(--form-padding-right);
}
 .body__form h1 {
	 font-size: 2.25rem;
}
 .body__form label {
	 font-weight: 400;
}
 .body__form .fm-enqueteout {
	 border-collapse: var(--table--form-border-collapse);
	 border-style: none;
	 width: var(--container--form-width);
	 margin: var(--table--margin-inset);
}
 .body__form .fm-enquete {
	 border-collapse: var(--table--form-border-collapse);
	 border-color: var(--table--form-border-color);
	 border-style: var(--table--form-border-type);
	 border-width: var(--table--form-border-width);
	 width: var(--container--form-width);
	 margin: var(--table--margin-inset);
}
 .body__form .form__alert--error {
	 display: block;
	 text-align: var(--form-text-align-fm-answer);
	 font-family: var(--form-error-font-family);
	 font-size: var(--form-error-font-size);
	 color: var(--form-error-color);
	 list-style-type: var(--form-error-list-style-type);
}
 .body__form .form__alert--error span {
	 font-family: var(--form-error-font-family);
}
 .body__form .container__form {
	 position: relative;
}
 .body__form .container__form .fm-question, .body__form .container__form .fm-answer {
	 padding: var(--form-padding-block);
}
 .body__form .container__form .fm-question {
     background-color: var(--form-background-color-fm-question);
	 width: var(--form-width-fm-question);
	 border-style: var(--form--border-type);
	 border-color: var(--form--border-color);
	 border-width: var(--form--border-width);
	 text-align: var(--form-text-align-fm-question);
	 vertical-align: var(--form-vertical-align-fm-question);
}
 .body__form .container__form .fm-answer {
     word-break: break-all;
	 background-color: var(--form-background-color-fm-answer);
	 width: var(--form-width-fm-answer);
	 border-style: var(--form--border-type);
	 border-color: var(--form--border-color);
	 border-width: var(--form--border-width);
	 text-align: var(--form-text-align-fm-answer);
	 vertical-align: var(--form-vertical-align-fm-answer);
}
 .body__form .form__btn-secondary, .body__form .btn-back-form {
	 width: 45%;
	 white-space: normal;
	 font-weight: bold;
	 font-size: clamp(16px, 85%, 22px);
	 border: 1px solid #777;
	 padding: 8px 3%;
}
 .body__form .form__btn-secondary:hover, .body__form .btn-back-form:hover {
	 opacity: 0.8;
}
 .body__form .form__btn-secondary {
	 color: #fff;
	 background: #777;
	 vertical-align: top;
}
 .body__form .btn-back-form {
	 color: #777;
	 background: #fff;
	 border-radius: 5px;
}
 .body__form .btn-info {
	 color: #fff;
	 background-color: #4aa3ff;
	 border-color: #4aa3ff;
}
 .body__form .btn-info:hover {
	 opacity: 0.8;
}
 .body__form textarea::placeholder, .body__form input::placeholder {
	 color: var(--form-placerholder-color);
}
 .search-address-form {
	 font-family: var(--form-font-family);
	 font-size: var(--form-font-size);
	 color: var(--form-color);
}
 .search-address-form span {
	 font-size: var(--form-font-size);
}
 

</style>`;
const ID_PAGE_TYPE = {
    A: 1,
    B: 2,
    C: 3,
    I: 9
};

const PAGE_TYPE_FIXED = [
    { id: ID_PAGE_TYPE.A, name: 'A', alias: 'a', label: '通常フォーム' },
    { id: ID_PAGE_TYPE.B, name: 'B', alias: 'b', label: 'シリアルIWフォーム' },
    { id: ID_PAGE_TYPE.I, name: 'I', alias: 'i', label: '空メールフォーム' },
    { id: ID_PAGE_TYPE.C, name: 'C', alias: 'c', label: '表示ページ' }
];

const PAGE_TYPES = {
    _A: ['page_inputs', 'page_confirms', 'page_completes'],
    _B: ['page_input_serial_code', 'page_lottery', 'page_win_prize', 'page_not_win_prize', 'page_confirm_serial_code'],
    _C: ['page_inputs'],
    _I: ['page_registration_mail', 'page_confirm_mail', 'page_complete_mail', 'registration_email_template']
};

const TAB_NAME = {
    basic: '基本設定',
    design: 'デザイン設定',
    page: 'ページ設定',
    page_setting_mail_type_i: '空メール設定',
    page_setting_lottery: i18n.t('managerForm.settingSerialCode.tabLottery'),
    page_setting_serial_code: 'シリアルコード設定',
    page_setting_prize: i18n.t('managerForm.settingSerialCode.tabListPrize'),
    page_setting_calendar_lottery: i18n.t('managerForm.settingSerialCode.tabLotteryCalendar')
};

const TABS = () => {
    return [
        {
            id: 1,
            name: TAB_NAME.basic,
            disabled: false
        },
        {
            id: 2,
            name: TAB_NAME.design,
            disabled: false
        },
        {
            id: 3,
            name: TAB_NAME.page,
            disabled: false
        },
        {
            id: 4,
            name: TAB_NAME.page_setting_mail_type_i,
            disabled: false
        },
        {
            id: 6,
            name: TAB_NAME.page_setting_serial_code,
            disabled: false
        },
        {
            id: 7,
            name: TAB_NAME.page_setting_prize,
            disabled: false
        },
        {
            id: 8,
            name: TAB_NAME.page_setting_calendar_lottery,
            disabled: false
        }
    ];
};

const STATUS_FORM_LIST = {
    CREATED: 1, //created 編集中
    RESERVING: 2, //予約中
    PUBLISHING: 3, // 公開中
    UNPUBLISHED: 4 // 公開停止
};

const STATUS_FORM = [
    {
        id: STATUS_FORM_LIST.CREATED,
        value: '編集中',
        backgroundColor: '#ffa50073'
    },
    {
        id: STATUS_FORM_LIST.RESERVING,
        value: '予約中',
        backgroundColor: '#4aa3ffa1'
    },
    {
        id: STATUS_FORM_LIST.PUBLISHING,
        value: '公開中',
        backgroundColor: '#ff00006b'
    },
    {
        id: STATUS_FORM_LIST.UNPUBLISHED,
        value: '公開停止',
        backgroundColor: '#80808066'
    }
];

const configs = {
    campaign: {
        trackBy: 'id',
        label: 'name',
        error: false,
        isRemove: false
    },
    nameForm: {
        trackBy: 'id',
        label: 'name',
        error: false,
        isRemove: false
    },
    client: {
        trackBy: 'id',
        label: 'name',
        error: false,
        isRemove: false
    },
    configTable: {
        nameTable: 'ListForm',
        widthAction: 340,
        headers: [
            {
                label: 'ID',
                width: 60
            },
            {
                label: i18n.t('managerForm.list.nameCampaign'),
                width: 220
            },
            {
                label: i18n.t('managerForm.list.nameForm'),
                width: 150
            },
            {
                label: i18n.t('managerForm.settingPage.pageType'),
                width: 120
            },
            {
                label: i18n.t('managerForm.list.urlPublic'),
                width: 200
            },
            {
                label: i18n.t('managerForm.list.status'),
                width: 100
            },
            {
                label: i18n.t('managerForm.list.schedule'),
                width: 142
            }
        ]
    },
    configTableAnalytics: {
        headers: [
            {
                label: 'ID'
            },
            {
                label: '回答日時'
            },
            {
                label: '更新日時'
            },
            {
                label: 'Ô nhập 1'
            },
            {
                label: 'Block va test publish'
            }
        ]
    },
    configModalAnalyticsDetail: {
        title: '',
        model: false,
        scrollable: true,
        hideFooter: true,
        centered: true,
        validate: true,
        size: 'lg'
    },
    configModalAnalyticsEdit: {
        title: '',
        model: false,
        scrollable: true,
        hideFooter: false,
        centered: true,
        validate: true,
        size: 'lg'
    },
    configPage: {
        total: 0,
        limit: 10,
        page: 1
    },
    configKeyword: {
        arrayTag: [],
        placeholder: 'キャンペーン名称、フォーム名、公開URL',
        isShowLable: true
    },
    configModalSettingDatePublish: {
        title: '',
        model: false,
        scrollable: true,
        hideFooter: false,
        centered: true,
        validate: true,
        size: 'lg'
    },
    configModalListPrv: {
        title: '',
        model: false,
        scrollable: true,
        hideFooter: false,
        centered: false,
        size: 'xl'
    },
    configModalPrvForm: {
        title: i18n.t('btn.preview'),
        model: false,
        scrollable: true,
        hideFooter: false,
        centered: true,
        size: 'sm'
    }
};

const initFormSearch = () => {
    return {
        campaign: null,
        name: null,
        status: [],
        tag: null,
        client: null,
        date_from: {
            campaign_start_date: '',
            campaign_end_date: '',
            secretariat_end_date: ''
        },
        date_to: {
            campaign_start_date: '',
            campaign_end_date: '',
            secretariat_end_date: ''
        },
        only_trashed: false,
        has: {
            partner: isRolePartner() ? getInfoUserLocalStorage().partner_id ?? '' : ''
        }
    };
};

const TEMPORARILY = [
    {
        id: 1,
        value: '無効'
    },
    {
        id: 2,
        value: '有効'
    }
];

const OPTION_PUBLIC_START_FORM = [
    {
        id: 1,
        name: '即時に公開する'
    },
    {
        id: 0,
        name: '公開開始日時を設定する'
    }
];
const OPTION_PUBLIC_END_FORM = [
    {
        id: 1,
        name: '設定しない'
    },
    {
        id: 0,
        name: '公開終了日時を設定する'
    }
];

const SOCIAL_MEDIA_LOGIN = [
    {
        id: 1,
        name: 'X',
        value: ''
    },
    {
        id: 2,
        name: 'Facebook',
        value: ''
    },
    {
        id: 3,
        name: 'TikTok',
        value: ''
    },
    {
        id: 4,
        name: 'Apple',
        value: ''
    },
    {
        id: 5,
        name: 'Line',
        value: ''
    },
    {
        id: 6,
        name: 'Google',
        value: ''
    },
    {
        id: 7,
        name: 'Yahoo',
        value: ''
    }
];

const initLayoutPrizeSerial = (data = null) => {
    return {
        direction: data?.direction ? data?.direction : OPTION_DESIGN_PRIZE_FORM_B.listSortDirection[0],
        arrangement: data?.arrangement ? data.arrangement : OPTION_DESIGN_PRIZE_FORM_B.listSortArrangement[1]
    };
};

const initSettingPage = (typePage = 1) => {
    let pageType = [];
    const pageDefault = [
        {
            id: 1,
            title: i18n.t('managerForm.settingPage.screenInput'),
            page_child: [
                {
                    id: 1,
                    name_page: 'フロントページ',
                    is_default: true,
                    blocks: [],
                    type_page_wl: PAGE_TYPES._A[0]
                }
            ],
            is_accept_add: true
        },
        {
            id: 2,
            title: i18n.t('managerForm.settingPage.screenConfirm'),
            page_child: [
                {
                    id: 1,
                    name_page: '確認ページ',
                    is_default: true,
                    blocks: [],
                    type_page_wl: PAGE_TYPES._A[1]
                }
            ],
            is_accept_add: false,
            setting_buttons: {
                label_btn_confirm: '登録',
                label_btn_back: '戻る',
                img_btn_confirm: null,
                img_btn_back: null
            }
        },
        {
            id: 3,
            title: i18n.t('managerForm.settingPage.screenComplete'),
            page_child: [
                {
                    id: 1,
                    name_page: '完了ページ',
                    is_default: true,
                    blocks: [],
                    type_page_wl: PAGE_TYPES._A[2]
                }
            ],
            is_accept_add: false
        }
    ];
    switch (typePage) {
        case 1:
            pageType = pageDefault;
            break;
        case ID_PAGE_TYPE.C:
            pageType = [pageDefault[0]];
            break;
        case 2:
            pageType = [
                {
                    id: 1,
                    title: i18n.t('managerForm.settingPage.pageTypeB.enterSericode'),
                    page_child: [
                        {
                            id: 1,
                            name_page: 'ユーザがシリアルコードを入力する画面の設定',
                            is_default: true,
                            extension: null,
                            blocks: initSerialCodeInputBlock(),
                            type_page_wl: PAGE_TYPES._B[0],
                            setting_buttons: {
                                label_btn_register: i18n.t('managerForm.settingPage.btnSaveForm'),
                                img_btn_register: null
                            },
                            setting_requires: null,
                            setting_confirms: null,
                            setting_layout_prize_serial: initLayoutPrizeSerial()
                        }
                    ],
                    is_accept_add: true
                },
                {
                    id: 2,
                    title: i18n.t('managerForm.settingPage.pageTypeB.lotterySericode'),
                    page_child: [
                        {
                            id: 1,
                            name_page: '抽選中画面の設定',
                            is_default: true,
                            type_page_wl: PAGE_TYPES._B[1],
                            blocks: [],
                            extension: {
                                display_btn_skip: true,
                                automatic_redirect_after: 10,
                                btn_skip: '抽選結果を確認する'
                            }
                        }
                    ],
                    is_accept_add: true
                },
                // {
                //     id: 3,
                //     title: i18n.t('managerForm.settingPage.pageTypeB.winningSericode'),
                //     page_child: [
                //         {
                //             id: 1,
                //             name_page: '当選時の画面設定',
                //             is_default: true,
                //             type_page_wl: PAGE_TYPES._B[2],
                //             extension: {
                //                 text_above: '',
                //                 text_below: ''
                //             }
                //         }
                //     ],
                //     is_accept_add: true
                // },
                {
                    id: 4,
                    title: i18n.t('managerForm.settingPage.pageTypeB.rejectionSericode'),
                    page_child: [
                        {
                            id: 1,
                            name_page: '落選時の画面設定',
                            is_default: true,
                            type_page_wl: PAGE_TYPES._B[3],
                            blocks: [],
                            extension: {
                                text_above: '',
                                text_below: '',
                                no_win_content: ''
                            }
                        }
                    ],
                    is_accept_add: true
                },
                ...pageDefault
            ];
            break;
        case 9:
            pageType = [
                {
                    id: 1,
                    title: i18n.t('managerForm.settingPage.screenEmail'),
                    page_child: [
                        {
                            id: 1,
                            name_page: '空メール登録ページ',
                            is_default: true,
                            type_page_wl: PAGE_TYPES._I[0],
                            extension: {
                                content: '',
                                confirm_input_twice: true
                            },
                            setting_buttons: {
                                label_btn_register: i18n.t('managerForm.settingPage.btnSaveForm'),
                                img_btn_register: null
                            },
                            setting_requires: {
                                display: 1,
                                label_required: '※必須',
                                position: 'after',
                                font: {
                                    id: 2,
                                    label: "'NotoSansJP', sans-serif",
                                    value: "'NotoSansJP', sans-serif",
                                    url: 'https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100..900&family=Yuji+Mai&display=swap'
                                },
                                font_size: 13,
                                unit: { label: 'px(ピクセル)', value: 'px' },
                                color: '#D10000'
                            },
                            setting_confirms: {
                                display: 1,
                                label_required: '(確認)',
                                font: {
                                    id: 2,
                                    label: "'NotoSansJP', sans-serif",
                                    value: "'NotoSansJP', sans-serif",
                                    url: 'https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100..900&family=Yuji+Mai&display=swap'
                                },
                                font_size: 13,
                                unit: { label: 'px(ピクセル)', value: 'px' },
                                color: '#333333'
                            }
                        },
                        {
                            id: 2,
                            name_page: '空メール確認ページ',
                            is_default: true,
                            type_page_wl: PAGE_TYPES._I[1],
                            extension: {
                                content: ''
                            },
                            setting_buttons: {
                                label_btn_confirm: '登録',
                                label_btn_back: '戻る',
                                img_btn_confirm: null,
                                img_btn_back: null
                            }
                        },
                        {
                            id: 3,
                            name_page: '空メール完了ページ',
                            is_default: true,
                            type_page_wl: PAGE_TYPES._I[2],
                            extension: {
                                content: ''
                            }
                        }
                    ],
                    is_accept_add: true
                },
                ...pageDefault
            ];
            break;
    }
    return {
        pages: pageType.map((item, idx) => {
            item.id = idx + 1;
            return item;
        }),
        specified_number_of_applications_end_screen: false,
        screen_before_application_period_starts: false,
        application_period_end_screen: false,
        unknown_error: false,
        login: false,
        my_page: false
    };
};

const initFormPage = () => {
    return {
        page_inputs: [],
        page_confirms: null,
        page_completes: null
    };
};

const initSettingDesgin = () => {
    return {
        title: '',
        head_text: HEADE_DEFAULT,
        character_settings: {
            qa_typography: {
                font: {
                    id: 2,
                    label: "'NotoSansJP', sans-serif",
                    value: "'NotoSansJP', sans-serif",
                    url: 'https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100..900&family=Yuji+Mai&display=swap'
                },
                font_size: 16,
                unit: { label: 'px(ピクセル)', value: 'px' },
                color: '#333333'
            },
            error_typography: {
                font: {
                    id: 2,
                    label: "'NotoSansJP', sans-serif",
                    value: "'NotoSansJP', sans-serif",
                    url: 'https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100..900&family=Yuji+Mai&display=swap'
                },
                font_size: 16,
                unit: { label: 'px(ピクセル)', value: 'px' },
                color: '#D10000'
            },
            // heading_style: { label: 'なし(none)', value: 'none' },
            color_input_placeholder: '#999999'
        },
        background_settings: {
            background_color: '#ffffff',
            is_full_width_bg_image: false,
            repeat: [],
            horizontal_direction: { label: '無指定', value: 'none' },
            vertical_direction: { label: '無指定', value: 'none' }
        },
        background_image: null,
        table_settings: {
            width: {
                unit: { label: 'px(ピクセル)', value: 'px' },
                table_width: 800,
                question_width: 300,
                answer_width: 500
            },
            display_position_in_browser: {
                top: {
                    value: 20,
                    unit: { label: 'px(ピクセル)', value: 'px' }
                },
                left: {
                    value: 0,
                    unit: { label: 'px(ピクセル)', value: 'px' }
                },
                bottom: {
                    value: 20,
                    unit: { label: 'px(ピクセル)', value: 'px' }
                },
                right: {
                    value: 0,
                    unit: { label: 'px(ピクセル)', value: 'px' }
                }
            },
            layout_alignment_setting: '',
            // block_display_alignment: 'align_center',
            question_layout: 'horizontal',
            border_setting: {
                type: options.borderTypes[1],
                color: '#C0C0C0'
            },
            line_thickness: {
                value: 1,
                unit: { label: 'px(ピクセル)', value: 'px' }
            },
            line_display: 'collapse',
            cell_setting: {
                spacing: {
                    value: 0,
                    unit: { label: 'px(ピクセル)', value: 'px' }
                },
                margin: {
                    value: 20,
                    unit: { label: 'px(ピクセル)', value: 'px' }
                }
            },
            cell_background_color: {
                question_background_color: '#F5F5F5',
                answer_background_color: '#ffffff'
            },
            question_text_alignment: {
                horizontal: 'align_left',
                vertical: 'align_center'
            },
            answer_text_alignment: {
                horizontal: 'align_left',
                vertical: 'align_center'
            }
        }
    };
};

const initForm = () => {
    return {
        // setting basic
        campaign: getInfoUserLocalStorage()?.default_campaign ?? null,
        client: null,
        name: '',
        status: 1,
        is_publish_start_date_now: 1,
        publish_start_date: '',
        publish_start_time: '',
        publish_end_date: '',
        publish_end_time: '',
        publish_has_no_end_date: 1,
        custom_domain_id: null,
        custom_domain: null,
        url_public: '',
        url_parameters: [],
        application_limit: '',
        url_redirect_when_limit: '',
        mail_to: '',
        save_form_temporarily: 1,
        temporary_expiration_date: '',
        hashtag: [],
        reservation_display_url: '',
        expired_display_url: '',
        setting_login_social: [],
        setting_my_page: false,
        published: null,
        published_domain: null,
        template: null,
        is_first_create: true,
        link_expiration_time: '',
        allow_duplicate_email: false,
        before_the_period_url: '',
        after_the_period_url: '',
        // setting design
        header: '',
        footer: '',
        google_analytics: '',
        meta_title: '',
        description: '',
        setting_designs: initSettingDesgin(),
        // setting page
        page_type: null,
        form_pages: initFormPage(),
        setting_page: initSettingPage(),
        registration_email_template: {
            type: 'text',
            invite: {
                template_name: '',
                body: '{{URL}}',
                subject: 'パルディアからのフォーム',
                template: null,
                email_sender: null
            }
        },
        setting_not_register_again: null,

        // setting serial-code
        setting_serial_code: {
            serial_codes: [],
            mail_common: false
        },
        setting_lottery: {
            is_prize_before_the_draw: false,
            used_code: 1,
            start_date: '',
            end_date: '',
            start_time_winning: '00:00',
            end_time_winning: '23:59'
        },
        serial_code_prizes: [],
        // setting digital-gift
        setting_digital_gift: {
            title_digital: '',
            top_text_digital: '',
            bottom_text_digital: '',
            selected_item_digital: '',
            probability_of_winning_digital: '',
            result_digital: '',
            rejection_text_digital: ''
        }
    };
};

const initSettingDate = () => {
    return {
        is_publish_start_date_now: 1,
        publish_start_date: '',
        publish_start_time: '',
        publish_end_date: '',
        publish_end_time: '',
        publish_has_no_end_date: 1
    };
};

const configSettingDate = () => {
    return {
        configFieldPublicationStartDateTime: {
            minuteStep: 1,
            placeholderTime: '',
            errorText: '',
            valueSync: '',
            error: false,
            typesValidate: ['dateTime', 'requiredDate'],
            errorField: i18n.t('managerForm.settingBasic.scheduleStart')
        },
        configFieldPublicationEndDateTime: {
            minuteStep: 1,
            placeholderTime: '',
            errorText: '',
            valueSync: '',
            error: false,
            typesValidate: ['dateTime', 'requiredDate'],
            errorField: i18n.t('managerForm.settingBasic.scheduleEnd')
        }
    };
};

const reorderTabs = () => {
    const tabs = TABS();
    const itemSerialCode = tabs.find((tab) => tab.name === TAB_NAME.page_setting_serial_code);
    return tabs.reduce((acc, tab) => {
        if (tab.name === TAB_NAME.page) {
            if (!acc.some((t) => t.name === TAB_NAME.page_setting_serial_code)) {
                acc.push(itemSerialCode);
            }
            acc.push(tab);
        } else if (tab.name !== TAB_NAME.page_setting_serial_code) {
            acc.push(tab);
        }
        return acc;
    }, []);
};

const onHandleTabForm = (pageTypeId) => {
    switch (pageTypeId) {
        case ID_PAGE_TYPE.A:
        case ID_PAGE_TYPE.C:
            return TABS().filter((tab) => ![4, 5, 6, 7, 8].includes(tab.id));
        case ID_PAGE_TYPE.I:
            return TABS().filter((tab) => ![5, 6, 7, 8].includes(tab.id));
        case ID_PAGE_TYPE.B:
            return reorderTabs().filter((tab) => tab.id !== 4);
    }
};

const initInputCalendar = (data = null) => {
    const totalNumberDaily = () => {
        return !!data?.daily_accumulated_limit?.toString() && !!data?.daily_won?.toString()
            ? Number(data?.daily_accumulated_limit) + Number(data?.daily_won)
            : null;
    };
    return {
        ...(data?.id !== null &&
            data?.id !== undefined && {
                id: createIdEventRangeDate({
                    startStr: data?.specific_date ?? null,
                    endStr: data?.specific_date ? toCalendarEnd(data.specific_date) : null
                })
            }),
        title: totalNumberDaily(),
        daily_limit: totalNumberDaily(),
        startStr: data?.specific_date ?? null,
        endStr: data?.specific_date ? toCalendarEnd(data.specific_date) : null,
        start: data?.specific_date ? new Date(data.specific_date) : null,
        end: data?.specific_date ? new Date(toCalendarEnd(data.specific_date)) : null,
        allDay: true,
        extendedProps: {
            source: 'server',
            id: data?.id ?? null,
            daily_won: data?.daily_won || 0,
            daily_accumulated_limit: data?.daily_accumulated_limit?.toString() ?? ''
        }
    };
};

const initOutputCalendar = (data = null) => {
    const id = data?.extendedProps?.id ?? data?.id ?? null;
    const isServer = data?.extendedProps?.source === 'server' || (!data?.extendedProps && data?.id);
    return {
        ...(id !== null && isServer && { id: Number(id) }),
        specific_date: data?.startStr || data?.specific_date || null,
        daily_limit: (data?.title ?? data?.daily_limit) !== null ? Number(data?.title ?? data?.daily_limit) : null
    };
};

export {
    STATUS_FORM,
    configs,
    TEMPORARILY,
    SOCIAL_MEDIA_LOGIN,
    TABS,
    TAB_NAME,
    OPTION_PUBLIC_START_FORM,
    OPTION_PUBLIC_END_FORM,
    PAGE_TYPE_FIXED,
    ID_PAGE_TYPE,
    STATUS_FORM_LIST,
    PAGE_TYPES,
    initForm,
    initFormSearch,
    initSettingDate,
    configSettingDate,
    initSettingPage,
    initFormPage,
    initSettingDesgin,
    onHandleTabForm,
    initInputCalendar,
    initOutputCalendar,
    initLayoutPrizeSerial
};
